import api from '../config/api';
import { formatDateDisplay } from './formatDate';

function itemName(it) {
  if (it.item_type === 'Desserts') return it.dessert_name || 'Dessert';
  if (it.item_type === 'Grazing Table') return it.custom_item_name || 'Grazing item';
  return it.custom_item_name || it.item_type;
}

export function buildEventQuotationShareText(order) {
  const party = order.party_name || order.caterer_name || '—';
  const lines = [
    `CakeXpress – Order details`,
    `Order: ${order.order_number}`,
    `Category: ${order.category}`,
    `Party / Caterer: ${party}`,
    `Event date: ${formatDateDisplay(order.event_date || order.delivery_date)}`,
    `Event time: ${order.event_time ? String(order.event_time).slice(0, 5) : '—'}`,
    `Venue: ${order.event_venue || '—'}`,
    `Customer: ${order.customer_name || '—'}`,
    ''
  ];
  (order.items || []).forEach((it, i) => {
    lines.push(
      `${i + 1}. ${itemName(it)} × ${it.quantity} · ₹${Number(it.total_price || 0).toFixed(2)}`
    );
  });
  const itemsTotal = (order.items || []).reduce((s, it) => s + (parseFloat(it.total_price) || 0), 0);
  const travel = parseFloat(order.travel_expense || 0);
  lines.push('');
  lines.push(`Items: ₹${itemsTotal.toFixed(2)}`);
  lines.push(`Travel: ₹${travel.toFixed(2)}`);
  lines.push(`Total: ₹${(itemsTotal + travel).toFixed(2)}`);
  return lines.join('\n');
}

/**
 * Fetch event quotation PDF and share via WhatsApp (file share when possible).
 */
export async function shareEventQuotationWhatsApp(order, orderId, phone) {
  if (!order || orderId == null) return;

  let blob;
  try {
    const response = await api.get(`/pdf/event-quotation/${orderId}`, { responseType: 'blob' });
    blob = response.data;
  } catch (error) {
    console.error('Event quotation fetch:', error);
    const msg = error.response?.data?.error || error.message || 'Error generating quotation PDF';
    alert(typeof msg === 'string' ? msg : 'Error generating quotation PDF');
    return;
  }

  const filename = `CakeXpress-${order.order_number || orderId}-order-details.pdf`;
  const file = new File([blob], filename, { type: 'application/pdf' });
  const caption = `CakeXpress order details – ${order.order_number} · ${order.customer_name || ''}`.trim();

  try {
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], title: 'CakeXpress Order details', text: caption });
      return;
    }
  } catch (e) {
    if (e.name === 'AbortError') return;
  }

  // Download PDF then open WhatsApp with text (and phone if available)
  const urlObj = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = urlObj;
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(urlObj), 2000);

  const text = buildEventQuotationShareText(order);
  const digits = String(phone || order.customer_phone || order.caterer_phone || '').replace(/\D/g, '');
  const waPhone = digits.length >= 10 ? (digits.length === 10 ? `91${digits}` : digits) : '';
  const waUrl = waPhone
    ? `https://wa.me/${waPhone}?text=${encodeURIComponent(text)}`
    : `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(waUrl, '_blank', 'noopener,noreferrer');
}
